// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupContainer_u6YwT {
	position: absolute;
	top: 54px;
	left: 0;
	width: 100%;
	max-height: 200px;
	overflow-y: auto;
	background-color: var(--f5-background);
	border-radius: 8px;
	padding: 8px 0;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	z-index: 100000;
}

.fromEventPopupContainer_EW4Fv {
	position: absolute;
	top: 35px;
	left: 0;
	width: 100%;
	max-height: 200px;
	overflow-y: auto;
	background-color: var(--f5-background);
	border-radius: 8px;
	padding: 8px 0;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	z-index: 100000;
}
.participantCard_EZt79 {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 3px;
	background-color: var(--_16c0982e-background);
	color: var(--_10a37f-background);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	margin-left: auto;
	padding: 2px;
	position: absolute;
	top: 3px;
	right: 3px;
}

.fromSettingsPopupContainer_uTtVw {
	position: absolute;
	top: 45px;
	left: 0;
	width: 100%;
	max-height: 200px;
	overflow-y: auto;
	background-color: var(--f5-background);
	border-radius: 8px;
	padding: 8px 0;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	z-index: 100000;
}

.userCard_SH0RH {
	display: flex;
	align-items: center;
	padding: 6px;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	position: relative;
	&:hover {
		background: var(--_16c0982e-background);
	}
}

.userCard_SH0RH:last-child {
	border-bottom: none;
}

.avatar_ifiAV {
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 5px;
	background-color: #f0f0f0;
	display: flex;
	align-items: center;
	justify-content: center;
	text-transform: uppercase;
	font-weight: 600;
}

.avatar_ifiAV img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.initial_MFQWn {
	font-size: 17px;
	color: white;
	background-color: #4285f4;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
}

.userInfo_qWJUO {
	display: flex;
	flex-direction: column;
}

.userName_GWc5j {
	font-size: 14px;
	line-height: 1;
	font-weight: bold;
	color: var(--_3c3a3a-color);
}

.userEmail_pJpw9 {
	font-size: 12px;
	color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CalendarUsersPopUp.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,sCAAsC;CACtC,kBAAkB;CAClB,cAAc;CACd,wCAAwC;CACxC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,sCAAsC;CACtC,kBAAkB;CAClB,cAAc;CACd,wCAAwC;CACxC,eAAe;AAChB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,6CAA6C;CAC7C,gCAAgC;CAChC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,sCAAsC;CACtC,kBAAkB;CAClB,cAAc;CACd,wCAAwC;CACxC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,WAAW;AACZ","sourcesContent":[".popupContainer {\n\tposition: absolute;\n\ttop: 54px;\n\tleft: 0;\n\twidth: 100%;\n\tmax-height: 200px;\n\toverflow-y: auto;\n\tbackground-color: var(--f5-background);\n\tborder-radius: 8px;\n\tpadding: 8px 0;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tz-index: 100000;\n}\n\n.fromEventPopupContainer {\n\tposition: absolute;\n\ttop: 35px;\n\tleft: 0;\n\twidth: 100%;\n\tmax-height: 200px;\n\toverflow-y: auto;\n\tbackground-color: var(--f5-background);\n\tborder-radius: 8px;\n\tpadding: 8px 0;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tz-index: 100000;\n}\n.participantCard {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 3px;\n\tbackground-color: var(--_16c0982e-background);\n\tcolor: var(--_10a37f-background);\n\tcursor: pointer;\n\tuser-select: none;\n\tmargin-left: auto;\n\tpadding: 2px;\n\tposition: absolute;\n\ttop: 3px;\n\tright: 3px;\n}\n\n.fromSettingsPopupContainer {\n\tposition: absolute;\n\ttop: 45px;\n\tleft: 0;\n\twidth: 100%;\n\tmax-height: 200px;\n\toverflow-y: auto;\n\tbackground-color: var(--f5-background);\n\tborder-radius: 8px;\n\tpadding: 8px 0;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tz-index: 100000;\n}\n\n.userCard {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 6px;\n\tcursor: pointer;\n\tuser-select: none;\n\tposition: relative;\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t}\n}\n\n.userCard:last-child {\n\tborder-bottom: none;\n}\n\n.avatar {\n\twidth: 30px;\n\theight: 30px;\n\tmin-width: 30px;\n\tmin-height: 30px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n\tmargin-right: 5px;\n\tbackground-color: #f0f0f0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-transform: uppercase;\n\tfont-weight: 600;\n}\n\n.avatar img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.initial {\n\tfont-size: 17px;\n\tcolor: white;\n\tbackground-color: #4285f4;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n}\n\n.userInfo {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.userName {\n\tfont-size: 14px;\n\tline-height: 1;\n\tfont-weight: bold;\n\tcolor: var(--_3c3a3a-color);\n}\n\n.userEmail {\n\tfont-size: 12px;\n\tcolor: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupContainer": `popupContainer_u6YwT`,
	"fromEventPopupContainer": `fromEventPopupContainer_EW4Fv`,
	"participantCard": `participantCard_EZt79`,
	"fromSettingsPopupContainer": `fromSettingsPopupContainer_uTtVw`,
	"userCard": `userCard_SH0RH`,
	"avatar": `avatar_ifiAV`,
	"initial": `initial_MFQWn`,
	"userInfo": `userInfo_qWJUO`,
	"userName": `userName_GWc5j`,
	"userEmail": `userEmail_pJpw9`
};
export default ___CSS_LOADER_EXPORT___;
